import { AuthContext } from 'contexts';
import { useContext, useMemo } from 'react';
import type { CanManageBillingProfileType } from '../../../pages/SubscriptionsPaymentsPage/SubscriptionsPageContext';

/**
 * Hook to determine (via `response`) if the current user can manage billing details.
 * If the user does not have permission, the `message` field will contain the reason why.
 */
const useCanManageBilling = (): CanManageBillingProfileType => {
  const { auth } = useContext(AuthContext);

  return useMemo<CanManageBillingProfileType>(() => {
    const isAssumedUser =
      auth.assumingUserId !== undefined ||
      auth.isAssumedNotBB ||
      auth.assumerIdMlsStaff !== undefined;

    if (isAssumedUser) {
      return {
        response: false,
        message: 'You cannot manage billing details while assuming a user.',
      };
    }

    return {
      response: true,
    };
  }, [auth.assumingUserId, auth.isAssumedNotBB, auth.assumerIdMlsStaff]);
};

export default useCanManageBilling;
